import Config from '@/config'
import router from '@/router'
import store from '@/vuex/store'
import mixpanelUtils from '@/utils/mixpanel.utils'
import utils from '@/util'
import {
  OFFLINE_SERVICE_WORKER_FILENAME,
  canHostOfflineServiceWorker,
  isMobileDevice,
  startOfflineServiceWorker,
} from '@/services/offlineServiceWorker'
import { capturePageLoad, trackPageRenderFromCache, trackProfileRenderFromCache } from '@/services/offlineRenderTiming'

export default function bootOfflineServiceWorker() {
  const serviceWorkerUrl = `${process.env.BASE_URL}${OFFLINE_SERVICE_WORKER_FILENAME}`
  const canHost = canHostOfflineServiceWorker({
    location: window.location,
    environment: Config.env,
    serviceWorkerUrl,
    localOverride: process.env.VUE_APP_OFFLINE_SW,
    isAddinBuild: Config.isEnableAddinPowerpoint,
    integrationPlatform: Config.integrationPlatform,
    isTopWindow: window.top === window.self,
    hasServiceWorkerApi: 'serviceWorker' in navigator,
  })
  if (!canHost) return
  const pageLoad = capturePageLoad({ router })
  startOfflineServiceWorker({
    store,
    serviceWorkerContainer: navigator.serviceWorker,
    cacheStorage: window.caches,
    serviceWorkerUrl,
    isSignedIn: utils.isLoggedIn,
    isMobile: isMobileDevice(navigator),
    onRegistered: () => router.onReady(() => {
      trackPageRenderFromCache({ pageLoad, track: mixpanelUtils.track })
      trackProfileRenderFromCache({ pageLoad, track: mixpanelUtils.track })
    }),
  }).catch(() => {})
}
